import { render, staticRenderFns } from "./vue-video.vue?vue&type=template&id=cdd6772a&scoped=true"
import script from "./vue-video.vue?vue&type=script&lang=js"
export * from "./vue-video.vue?vue&type=script&lang=js"
import style0 from "./vue-video.vue?vue&type=style&index=0&id=cdd6772a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd6772a",
  null
  
)

export default component.exports